export enum authEnum {
  LOGIN = "login",
  REGISTER = "register",
  MOBILE = "mobile",
  EMAIL = "email",
  SMS = "sms",
  RESET = "reset",
  VERIFY = "verify",
}

export enum menuSliceEnum {
  LEVEL1 = "level1",
  LEVEL2 = "level2",
  LEVEL3 = "level3",
}

export enum localStorageEnum {
  ACCESS_TOKEN = "access_token",
  USER_ID = "userId",
}

export enum bannerTypeEnum {
  Type1 = "type1",
  Type2 = "type2",
  Type3 = "type3",
  Type4 = "type4",
  Type5 = "type5",
  Type6 = "type6",
  Type7 = "type7",
  Type8 = "type8",
  Type9 = "type9",
}
